import { TwitterTimelineEmbed } from "react-twitter-embed";
import { useState } from "react";

const TwitterFeed = ({ twitterUrl }) => {
  const [isLoading, setIsLoading] = useState(true);

  if (!twitterUrl) return null;

  const getTwitterUsername = (url) => {
    try {
      if (url.includes('twitter.com/') || url.includes('x.com/')) {
        return url.split('/').pop().split('?')[0];
      }
      return url.replace('@', '');
    } catch (error) {
      console.error('Error parsing Twitter URL:', error);
      return null;
    }
  };

  const username = getTwitterUsername(twitterUrl);
  if (!username) return null;

  return (
    <div className='pt-4 divide-y divide-dashed divide-gray-200 relative min-h-[400px] bg-white rounded-lg'>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-50/80 rounded-lg">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      )}
      <TwitterTimelineEmbed
        sourceType='profile'
        screenName={username}
        options={{ 
          height: 400,
          chrome: "noheader,nofooter",
          theme: "light"
        }}
        key={username}
        onLoad={() => setIsLoading(false)}
        noHeader
      />
    </div>
  );
};

export default TwitterFeed;